import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import layout from '../layout';
import formulas from '../formulas';
import visibility from '../visibility';
import bindingHelpers from '../binding/helpers';
import helpers from '../utils/fieldsHelper';
import formHelper from '../utils/formHelper';
import moment from 'moment';
import uuid from 'uuid';
/**
 *
 * @param {import('./types').EcrionFormField} field
 * @returns {boolean} True if current field is a container field
 */

var isFieldContainer = function isFieldContainer(field) {
  if (field.type === 'form' || field.type === 'subform' || field.type === 'page' || field.type === 'datagroup' || field.type === 'repeating') return true;
  return false;
};
/**
 * @param {import('./types').EcrionFormFieldType} fieldType
 * @return {boolean}
 */


var allowValidation = function allowValidation(fieldType) {
  return fieldType === 'textbox' || fieldType === 'textarea' || fieldType === 'dropdown' || fieldType === 'radiogroup' || fieldType === 'checkboxgroup' || fieldType === 'checkbox' || fieldType === 'date' || fieldType === 'time' || fieldType === 'datetime' || fieldType === 'image' || fieldType === 'signature' || fieldType === 'googleaddress' || fieldType === 'currency' || fieldType === 'number' || fieldType === 'file' || fieldType === 'password' || fieldType === 'rating' || fieldType === 'richtext' || fieldType === 'login';
};
/**
 * @param {import('./types').EcrionFormFieldType} fieldType
 * @return {boolean}
 */


var isHiddenField = function isHiddenField(fieldType) {
  return fieldType === 'script';
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @param {import('./types').EcrionFormFieldType} type
 * @return {import('./types').EcrionFormInputField} a form signature field
 */


var readInputField = function readInputField(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';
  var field = readDefaultField(element, parentField, type);
  field.name = element.getAttribute('name') || '';
  field.caption = element.getAttribute('caption') || '';
  field.labelPlacement = element.getAttribute('labelPosition') || 'left';
  field.maxCharacters = parseInt(element.getAttribute('maxCharactersCount') || '');
  field.isVisible = element.getAttribute('visible') !== 'false';
  field.placeholder = element.getAttribute('placeholder') || '';
  field.description = element.getAttribute('description') || '';
  if (allowValidation(type)) field.required = element.getAttribute('required') !== 'false';
  return field;
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @return {import('./types').EcrionFormSignatureField} a form signature field
 */


var readSignatureField = function readSignatureField(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readInputField(element, parentField, 'signature');
  var agreement = element.getAttribute('agreement');
  var recipientRole = element.getAttribute('recipientRole');
  var recipientName = element.getAttribute('recipientName');
  var clearSignature = element.getAttribute('clearSignature') || 'Clear';
  return _objectSpread({}, field, {
    agreement: agreement,
    recipientRole: recipientRole,
    recipientName: recipientName,
    clearSignature: clearSignature,
    type: 'signature'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @return {import('./types').EcrionFormRatingField} a form rating field
 */


var readRatingField = function readRatingField(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readInputField(element, parentField, 'rating');
  var scale = element.getAttribute('scale');
  var icon = element.getAttribute('icon');
  return _objectSpread({}, field, {
    scale: scale,
    icon: icon,
    type: 'rating'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionHyperlinkField}
 */


var readHyperlinkField = function readHyperlinkField(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readDefaultField(element, parentField, 'hyperlink');
  var url = element.getAttribute('url');
  var displayText = element.getAttribute('displayText');
  return _objectSpread({}, field, {
    url: url,
    displayText: displayText,
    type: 'hyperlink'
  });
};
/**
 * @param {Element} element
 * @returns {import('./types').EcrionScriptField}
 */


var readScriptField = function readScriptField(element) {
  var field = readDefaultField(element, null, 'script');
  var src = element.getAttribute('src');
  var script = element.getAttribute('script');
  return _objectSpread({}, field, {
    type: 'script',
    script: script,
    src: src
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionRichtextField}
 */


var readRichtextField = function readRichtextField(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readDefaultField(element, parentField, 'richtext');
  var toolbar = element.getAttribute('toolbar');
  return _objectSpread({}, field, {
    toolbar: toolbar,
    type: 'richtext'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionXmlField}
 */


var readXmlField = function readXmlField(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readDefaultField(element, parentField, 'xmlfield');
  var src = element.getAttribute('src');
  var workspace = element.getAttribute('workspace');
  return _objectSpread({}, field, {
    src: src,
    workspace: workspace,
    type: 'xmlfield'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionGoogleMapField}
 */


var readGoogleMap = function readGoogleMap(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readDefaultField(element, parentField, 'googlemap');
  var mapType = element.getAttribute('mapType');
  return _objectSpread({}, field, {
    mapType: mapType,
    type: 'googlemap'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionLoginField}
 */


var readLogin = function readLogin(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readDefaultField(element, parentField, 'login');
  return _objectSpread({}, field, {
    defaultValue: {
      Url: element.getAttribute('defaultUrl') || "".concat(window.location.protocol, "//").concat(window.location.host),
      Username: element.getAttribute('defaultUsername') || '',
      Environment: element.getAttribute('defaultEnvironment') || '',
      Password: '',
      Token: ''
    },
    type: 'login'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionCheckboxField}
 */


var readCheckbox = function readCheckbox(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readDefaultField(element, parentField, 'checkbox');
  var customRequired = element.getAttribute('customRequired') === 'true';
  var validationMessage = element.getAttribute('validationMessage') || '';
  return _objectSpread({}, field, {
    customRequired: customRequired,
    validationMessage: validationMessage,
    type: 'checkbox'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionFormRepeatingField}
 */


var readRepeating = function readRepeating(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readDefaultField(element, parentField, 'repeating');
  return _objectSpread({}, field, {
    maxItems: element.getAttribute('maxItemCount') || '',
    minItems: element.getAttribute('minItemCount') || '',
    showCollapsed: element.getAttribute('showCollapsed') === 'true',
    showEmptyItems: element.getAttribute('showEmptyItems') !== 'false',
    addBtnContent: element.getAttribute('addBtnContent') || '<span><i class="fa fa-plus-circle"></i>&nbsp;Add</span>',
    type: 'repeating'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionFormGroupField}
 */


var readDataGroup = function readDataGroup(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readDefaultField(element, parentField, 'datagroup');
  return _objectSpread({}, field, {
    showCollapsed: element.getAttribute('showCollapsed') === 'true',
    type: 'datagroup'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionFormDropdownField}
 */


var readDropdown = function readDropdown(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readInputField(element, parentField, 'dropdown');
  return _objectSpread({}, field, {
    options: createMultipleOptions(element),
    multiple: element.getAttribute('multiple') === 'true',
    type: 'dropdown'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionFormRadioGroupField}
 */


var readRadioGroup = function readRadioGroup(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readInputField(element, parentField, 'radiogroup');
  return _objectSpread({}, field, {
    options: createMultipleOptions(element),
    type: 'radiogroup'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionFormCheckboxGroupField}
 */


var readCheckboxGroup = function readCheckboxGroup(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var field = readInputField(element, parentField, 'checkboxgroup');
  return _objectSpread({}, field, {
    options: createMultipleOptions(element),
    type: 'checkboxgroup'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @param {import('./types').EcrionFormFieldType} type
 * @returns {import('./types').EcrionCommonDateProps}
 */


var readCommonDateProps = function readCommonDateProps(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var type = arguments.length > 2 ? arguments[2] : undefined;
  var field = readInputField(element, parentField, type);
  var futureDatesOnly = element.getAttribute('futureDatesOnly') === 'true';
  var pastDatesOnly = element.getAttribute('pastDatesOnly') === 'true';
  var lowerBound = element.getAttribute('lowerBound') || '';
  var upperBound = element.getAttribute('upperBound') || '';
  var dateFormat = element.getAttribute('dateFormat') || 'mm/dd/yyyy';
  var separator = element.getAttribute('separator') || '';
  return _objectSpread({}, field, {
    futureDatesOnly: futureDatesOnly,
    pastDatesOnly: pastDatesOnly,
    lowerBound: lowerBound,
    upperBound: upperBound,
    dateFormat: dateFormat,
    separator: separator
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionFormDateTimeField}
 */


var readDateTimeField = function readDateTimeField(element, parentField) {
  var field = readCommonDateProps(element, parentField, 'datetime');
  var timeFormat = element.getAttribute('timeFormat');
  timeFormat = timeFormat === '24 Hour' ? 'HH:mm' : 'hh:mm a';
  return _objectSpread({
    type: 'datetime',
    timeFormat: timeFormat
  }, field);
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionFormDateField}
 */


var readDateField = function readDateField(element, parentField) {
  var field = readCommonDateProps(element, parentField, 'date');
  return _objectSpread({}, field, {
    type: 'date'
  });
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionFormTimeField}
 */


var readTimeField = function readTimeField(element, parentField) {
  var field = readInputField(element, parentField, 'time');
  var timeFormat = element.getAttribute('timeFormat');
  timeFormat = timeFormat === '24 Hour' ? 'HH:mm:ss' : 'hh:mm:ss a';
  return _objectSpread({
    timeFormat: timeFormat,
    type: 'time'
  }, field);
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @return {import('./types').EcrionFormFileField}
 */


var readFileField = function readFileField(element, parentField) {
  var field = readInputField(element, parentField, 'file');
  var browseLocalFiles = element.getAttribute('browseLocalFiles') === 'true';
  var browseEOSFiles = element.getAttribute('browseEOSFiles') !== 'false';
  var extensions = element.getAttribute('extensions');
  var optimize = element.getAttribute('optimize');
  return _objectSpread({
    type: 'file',
    browseLocalFiles: browseLocalFiles,
    browseEOSFiles: browseEOSFiles,
    extensions: extensions,
    optimize: optimize
  }, field);
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @return {import('./types').EcrionFormImageField}
 */


var readImageField = function readImageField(element, parentField) {
  var field = readInputField(element, parentField, 'image');
  var optimize = element.getAttribute('optimize');
  return _objectSpread({
    type: 'image',
    optimize: optimize
  }, field);
};
/**
 * @param {Element} element
 * @returns {import('./types').EcrionFormRootField}
 */


var readFormField = function readFormField(element) {
  var field = readDefaultField(element, null, 'form');
  if (field.type !== 'form') return null;
  field.paginationType = element.getAttribute('paginationType');
  field.variant = element.getAttribute('variant') || 'outlined';
  field.backButtonTmpl = element.getAttribute('backButtonTmpl');
  field.continueButtonTmpl = element.getAttribute('continueButtonTmpl');
  field.submitTmpl = element.getAttribute('submitTmpl');
  field.contactAction = element.getAttribute('contactAction');
  field.contactType = element.getAttribute('contactType');
  field.cssFile = element.getAttribute('cssFile');
  field.cssContent = element.getAttribute('cssContent');
  field.validateBeforeNextPage = element.getAttribute('validateBeforeNextPage') === 'true';
  field.hideLookupButton = element.getAttribute('hideLookupButton') === 'true';
  field.enableAutomaticLookupOnLoad = element.getAttribute('enableAutomaticLookupOnLoad') === 'true';
  return field;
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @param {import('./types').EcrionFormFieldType} type
 * @returns {import('./types').EcrionFormField}
 */


var readDefaultField = function readDefaultField(element, parentField, type) {
  // use both 'id', 'internalId' or a generated uuid for backwards compatibility
  var id = element.getAttribute('id') || element.getAttribute('internalId') || uuid();
  var parentId = parentField && parentField.id;
  var name = element.getAttribute('name') || ''; // this id used to connect current element with another one from an external source
  // for example: for page elements, we use this id to identify wich document contains data from this page

  var externalId = element.getAttribute('externalId') || '';
  var required = allowValidation(type) && element.getAttribute('required') !== 'false';
  var labelPlacement = element.getAttribute('labelPosition') || 'left';
  var isVisible = element.getAttribute('visible') !== 'false';
  var caption = element.getAttribute('caption') || '';
  var description = element.getAttribute('description') || '';
  var placeholder = element.getAttribute('placeholder') || '';
  var rows = element.getAttribute('rows') || '';
  var defaultValue = type !== 'richtext' ? helpers.cleanupHtmlMarkup(element.getAttribute('default') || '') : element.getAttribute('default') || '';
  var readonly = element.getAttribute('readonly') === 'true';
  var mask = element.getAttribute('mask') || '';
  var format = element.getAttribute('format') || '';
  var validation = element.getAttribute('validation');
  var visibility = element.getAttribute('visibility');
  var shrink = element.getAttribute('shrink') || '0';
  var isContactField = element.getAttribute('isContactField') === 'true' || element.localName.toLowerCase() === 'contactfield';
  var xpath = element.getAttribute('xpath');
  var dataSource = element.getAttribute('dataSource');
  var diagramParam = element.getAttribute('diagramParam');
  var lookupVisiblity = element.getAttribute('lookupVisiblity');
  var hideInLookupDialog = element.getAttribute('hideInLookupDialog') === 'true';
  var lineBreak = element.getAttribute('linebreak') === 'true';
  var maxCharacters = parseInt(element.getAttribute('maxCharactersCount'));
  var permissions = helpers.parseFieldPermissions(element.getAttribute('perms') || '');
  var min = parseFloat(element.getAttribute('min'));
  var max = parseFloat(element.getAttribute('max'));
  return {
    id: id,
    parentId: parentId,
    type: type,
    externalId: externalId,
    name: name,
    caption: caption,
    required: required,
    labelPlacement: labelPlacement,
    isVisible: isVisible,
    description: description,
    placeholder: placeholder,
    rows: rows,
    defaultValue: defaultValue,
    readonly: readonly,
    validation: validation,
    mask: mask,
    min: min,
    max: max,
    format: format,
    shrink: shrink,
    visibility: visibility,
    isContactField: isContactField,
    lineBreak: lineBreak,
    maxCharacters: maxCharacters,
    xpath: xpath,
    dataSource: dataSource,
    diagramParam: diagramParam,
    lookupVisiblity: lookupVisiblity,
    hideInLookupDialog: hideInLookupDialog,
    permissions: permissions
  };
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @param {import('./types').EcrionFormFieldType} type
 * @returns {import('./types').EcrionFormField}
 */


var readField = function readField(element, parentField, type) {
  switch (type) {
    case 'form':
      return readFormField(element);

    case 'signature':
      return readSignatureField(element, parentField);

    case 'datetime':
      return readDateTimeField(element, parentField);

    case 'date':
      return readDateField(element, parentField);

    case 'time':
      return readTimeField(element, parentField);

    case 'rating':
      return readRatingField(element, parentField);

    case 'file':
      return readFileField(element, parentField);

    case 'image':
      return readImageField(element, parentField);

    case 'hyperlink':
      return readHyperlinkField(element, parentField);

    case 'script':
      return readScriptField(element);

    case 'richtext':
      return readRichtextField(element, parentField);

    case 'xmlfield':
      return readXmlField(element, parentField);

    case 'googlemap':
      return readGoogleMap(element, parentField);

    case 'login':
      return readLogin(element, parentField);

    case 'checkbox':
      return readCheckbox(element, parentField);

    case 'repeating':
      return readRepeating(element, parentField);

    case 'datagroup':
      return readDataGroup(element, parentField);

    case 'dropdown':
      return readDropdown(element, parentField);

    case 'radiogroup':
      return readRadioGroup(element, parentField);

    case 'checkboxgroup':
      return readCheckboxGroup(element, parentField);

    default:
      return readDefaultField(element, parentField, type);
  }
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormContainer} parentField
 * @returns {import('./types').EcrionFormField}
 */


var createField = function createField(element) {
  var parentField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var type = detectFieldType(element);
  if (type === 'unknown') return;
  var field = readField(element, parentField, type); // if hidden field, skip adding to parent

  if (isHiddenField(type)) return field;
  if (parentField) parentField.children = parentField.children || [];
  if (parentField) parentField.children.push(field.id);
  return field;
};
/**
 * @param {Element} element
 */


var createMultipleOptions = function createMultipleOptions(element) {
  var options = [];

  for (var idx = 0; idx < element.children.length; idx++) {
    var childElement = element.children[idx];

    if (childElement.localName === 'item') {
      options.push({
        label: childElement.getAttribute('caption'),
        value: childElement.getAttribute('value')
      });
    }
  }

  return options;
};
/**
 * @param {Element} element
 * @return {import('./types').EcrionFormFieldType}
 */


var detectFieldType = function detectFieldType(element) {
  if (!element) return 'unknown';
  var elementName = element.localName.toLowerCase();
  var typeAttribute = element.getAttribute('type');
  var nameAttribute = element.getAttribute('name');
  if (elementName === 'form') return 'form';
  if (elementName === 'page') return 'page';

  if (elementName === 'textbox') {
    if (typeAttribute === 'date') return 'date';
    if (typeAttribute === 'datetime') return 'time';
    if (typeAttribute === 'time') return 'datetime';
    if (typeAttribute === 'richtext') return 'richtext';
    return 'textbox';
  }

  if (elementName === 'number') return 'number';
  if (elementName === 'currency') return 'currency';
  if (elementName === 'password') return 'password';
  if (elementName === 'separator') return 'separator';
  if (elementName === 'hr' && typeAttribute === 'separator') return 'separator';
  if (elementName === 'check') return 'checkbox';
  if (elementName === 'subform') return 'subform';
  if (elementName === 'label') return 'label';
  if (elementName === 'textarea') return 'textarea';
  if (elementName === 'datagroup') return 'datagroup';
  if (elementName === 'dropdown') return 'dropdown';
  if (elementName === 'group' && typeAttribute === 'dropdown') return 'dropdown';
  if (elementName === 'checkbox') return 'checkboxgroup';
  if (elementName === 'group' && typeAttribute === 'checkbox') return 'checkboxgroup';
  if (elementName === 'radio') return 'radiogroup';
  if (elementName === 'group' && typeAttribute === 'radio') return 'radiogroup';
  if (elementName === 'time') return 'time';
  if (elementName === 'date') return 'date';
  if (elementName === 'datetime') return 'datetime';
  if (elementName === 'signature') return 'signature';
  if (elementName === 'rating') return 'rating';
  if (elementName === 'image') return 'image';
  if (elementName === 'file') return 'file';
  if (elementName === 'repeating') return 'repeating';
  if (elementName === 'widgetgoogleaddress') return 'googleaddress';
  if (elementName === 'widgetgooglemap') return 'googlemap';
  if (elementName === 'widgetscript') return 'script';
  if (elementName === 'widgetlogin') return 'login';
  if (elementName === 'contactfield' && nameAttribute === 'Subscriptions') return 'subscriptions';
  if (elementName === 'hyperlink') return 'hyperlink';
  if (elementName === 'richtext') return 'richtext';
  if (elementName === 'xmlfield') return 'xmlfield';
  return 'unknown';
};
/**
 * Read default values from fields definitions and set field data
 * @param {import('./types').EcrionFormState} state
 */


var readDefaultValues = function readDefaultValues(state) {
  if (!state.fields) return;
  Object.keys(state.fields).forEach(function (fieldId) {
    var field = state.fields[fieldId]; // repeating field has a default value of [0], meaning one item

    if (field.type === 'repeating') state.data[fieldId] = [0];
    var defaultValue = field.defaultValue;
    if (field.type === 'login') state.data[fieldId] = defaultValue;
    if (typeof defaultValue !== 'string') return; // no default value

    if (!defaultValue) return; // value depends on context, so it will be processed later

    if (defaultValue.search(/{[^}]+}?}/g) >= 0) return;
    state.data[fieldId] = defaultValue;
  });
};
/**
 *
 * @param {Document} form
 * @return {import('./types').EcrionFormState}
 */


var createFormStateFromForm = function createFormStateFromForm(form) {
  if (!form || !form.documentElement) return {
    stage: 'none'
  };
  var documentElement = form.documentElement;
  /**@type {import('./types').EcrionFormState} */

  var state = {
    fields: {},
    data: {},
    meta: {
      FORM_PAGES_FIELD: null,
      FORM: {
        dirty: false
      }
    },
    layout: {
      pages: []
    },
    options: {},
    renderOptions: {},
    visibility: {
      conditions: {},
      mapping: {}
    },
    formId: '',
    form: form,
    formBindings: {},
    dependencies: {},
    stage: 'formLoaded'
  };
  state.formId = readFormFields(state, documentElement, null, state.fields);
  readRenderOptions(state);
  readDefaultContext(state);
  readVisibility(state);
  readStaticHTML(documentElement, state);
  readFormulas(documentElement, state);
  readCustomValidation(documentElement, state);
  readLanguages(documentElement, state);
  readDefaultValues(state);
  calculateFieldsDependencies(state);
  calculateFieldsVisibility(state);
  readCollapeStateFromFields(state); // calculate layout based on current state

  state.layout = layout.calculate(state); // use first page as selected

  var pages = state.layout.pages;
  if (pages && pages.length > 0) state.meta['FORM_PAGES_FIELD'] = pages[0];
  return state;
};
/**
 * @param {Element} element
 * @param {import('./types').EcrionFormState} state
 * @param {import('./types').EcrionFormContainer} parentField
 * @param {import('./types').EcrionFormFields} fields
 * @return {string} The id of the form element
 */


var readFormFields = function readFormFields(state, element, parentField, fields) {
  var field = createField(element, parentField);
  if (!field) return;
  fields[field.id] = field; // add to fields list
  // add break field if required

  processLineBreak(field, parentField, fields); // if not a field container, return

  if (!isFieldContainer(field)) {
    bindingHelpers.readFieldBinding(state, field);
    return;
  }

  for (var idx = 0; idx < element.children.length; idx++) {
    readFormFields(state, element.children[idx], field, fields);
  }

  return field.id;
};
/**
 * @param {import('./types').EcrionFormField} field
 * @param {import('./types').EcrionFormContainer} parentField
 * @param {import('./types').EcrionFormFields} fields
 */


var processLineBreak = function processLineBreak(field, parentField, fields) {
  if (!field || !field.lineBreak) return;
  if (!parentField || !parentField.children) return;
  /** @type {import('./types').EcrionFormField} */

  var breakField = {
    id: uuid(),
    type: 'break',
    parentId: parentField.id,
    isVisible: true
  };
  fields[breakField.id] = breakField;
  parentField.children.push(breakField.id);
};
/**
 * @param {import('./types').EcrionFormState} state
 */


var readRenderOptions = function readRenderOptions(state) {
  var formField = state.fields[state.formId];
  if (!formField || formField.type !== 'form') return;
  state.renderOptions.hideLookupButton = formField.hideLookupButton;
  state.renderOptions.enableAutomaticLookupOnLoad = formField.enableAutomaticLookupOnLoad;
};
/**
 * Initialize default form context (current date, etc...)
 * @param {import('./types').EcrionFormState} state
 */


var readDefaultContext = function readDefaultContext(state) {
  var environmentVars = {};
  var momentUtc = moment.utc();
  environmentVars['Time'] = momentUtc.format('HH:mm:ss Z');
  environmentVars['Date'] = momentUtc.format('YYYY-MM-DD');
  environmentVars['Year'] = momentUtc.year();
  environmentVars['Month'] = momentUtc.format('M');
  environmentVars['MonthName'] = momentUtc.format('MMMM');
  environmentVars['Day'] = momentUtc.format('D');
  environmentVars['DayOfWeek'] = momentUtc.format('dddd');
  environmentVars['DayOfYear'] = momentUtc.format('DDD');
  environmentVars['WorkflowName'] = 'Send';
  state.context = state.context || {
    environmentVars: {}
  };
  state.context.environmentVars = environmentVars;
};
/**
 * Read visibility rules from the fields
 * @param {import('./types').EcrionFormState} state
 */


var readVisibility = function readVisibility(state) {
  // read visibility definitions from all fields and save them to the form
  var fieldsIds = Object.keys(state.fields);
  fieldsIds.forEach(function (fieldId) {
    var field = state.fields[fieldId];
    if (!field || !field.visibility) return;

    try {
      /** @type {Array<import('../visibility/types').VisibilityCondition>} */
      var visibilityConditions = JSON.parse(field.visibility); // save visibility conditions for current field

      state.visibility.conditions[field.id] = visibilityConditions; // calculate a map of visibility dependencies between fields

      visibilityConditions.forEach(function (condition) {
        if (!state.visibility.mapping[condition.field]) state.visibility.mapping[condition.field] = []; // already a mapping between fields

        if (state.visibility.mapping[condition.field].includes(field.id)) return; // current's field visibility depends on the field from condition

        state.visibility.mapping[condition.field].push(field.id);
      });
    } catch (error) {}
  });
};
/**
 *
 * @param {Element} element
 * @param {import('./types').EcrionFormState} state
 */


var readStaticHTML = function readStaticHTML(element, state) {
  state.staticHTML = '';

  for (var idx = 0; idx < element.children.length; idx++) {
    var staticHTML = element.children[idx];
    if (!staticHTML || staticHTML.localName !== 'staticHTML') continue;

    try {
      var staticHtmlValue = staticHTML.getAttribute('value');
      if (!staticHtmlValue) return;
      state.staticHTML = atob(staticHtmlValue);
    } catch (_unused) {// decoding base64 generated error
    }
  }
};
/**
 * Read formulas rules from the fields
 * @param {Element} element
 * @param {import('./types').EcrionFormState} state
 */


var readFormulas = function readFormulas(element, state) {
  state.formulas = {};

  for (var idx = 0; idx < element.children.length; idx++) {
    var _formulas = element.children[idx];
    if (!_formulas || _formulas.localName !== 'formulas') continue;
    if (!_formulas.children) continue;

    for (var childIdx = 0; childIdx < _formulas.children.length; childIdx++) {
      var formula = _formulas.children[childIdx];
      if (!formula || formula.localName !== 'formula') continue;
      var id = formula.getAttribute('id');
      var value = formula.getAttribute('value');
      state.formulas[id] = JSON.parse(value);
    }
  }
};
/**
 * Read custom validation from the main form definition
 * @param {Element} element
 * @param {import('./types').EcrionFormState} state
 */


var readCustomValidation = function readCustomValidation(element, state) {
  state.validationMethods = {};

  for (var idx = 0; idx < element.children.length; idx++) {
    var customValidation = element.children[idx];
    if (!customValidation || customValidation.localName !== 'customValidation') continue;
    if (!customValidation.children) continue;

    for (var childIdx = 0; childIdx < customValidation.children.length; childIdx++) {
      var method = customValidation.children[childIdx];
      var name = method.getAttribute('name');
      var message = method.getAttribute('message');
      var callbackStr = method.getAttribute('callback');
      if (!name || !callbackStr) continue;
      state.validationMethods[name] = {
        message: message,
        callback: eval('(' + callbackStr + ')')
      };
    }
  }
};
/**
 * Read formulas rules from the fields
 * @param {Element} element
 * @param {import('./types').EcrionFormState} state
 */


var readLanguages = function readLanguages(element, state) {
  state.languages = {};

  for (var idx = 0; idx < element.children.length; idx++) {
    var languages = element.children[idx];
    if (!languages || languages.localName !== 'languages') continue;
    if (!languages.children) continue;

    for (var childIdx = 0; childIdx < languages.children.length; childIdx++) {
      var language = languages.children[childIdx];
      if (!language || language.localName !== 'language') continue;
      var id = language.getAttribute('id');
      var name = language.getAttribute('caption');
      var direction = language.getAttribute('dir') === 'rtl' ? 'left-to-right' : 'right-to-left';
      /**@type {{ [fieldId: string]: import('./types').EcrionFieldTranslation }} */

      var translations = {};

      for (var stringIdx = 0; stringIdx < language.children.length; stringIdx++) {
        var stringElement = language.children[stringIdx];
        var fieldId = stringElement.getAttribute('f');
        var propertyName = stringElement.getAttribute('a');
        var translation = stringElement.getAttribute('v');
        if (!fieldId) continue;
        if (!translations[fieldId]) translations[fieldId] = {};
        translations[fieldId][propertyName] = translation;
      }

      state.languages[id] = {
        id: id,
        name: name,
        direction: direction,
        translations: translations
      };
    }
  }
};
/**
 * Calculate visibility for fields
 * @param {import('./types').EcrionFormState} state
 */


var calculateFieldsVisibility = function calculateFieldsVisibility(state) {
  if (!state.fields) return; // for all the fields, calculate the visibility

  var fieldsIds = Object.keys(state.fields);
  fieldsIds.forEach(function (fieldId) {
    var field = state.fields[fieldId];
    if (!field) return; // no action needed if the field is visible

    if (visibility.calculate(fieldId, state)) return; // hide the field

    formHelper.setMetaProp(state, fieldId, 'hidden', true);
  });
};
/**
 * Read collapse state from fields and save the information in meta
 * @param {import('./types').EcrionFormState} state
 */


var readCollapeStateFromFields = function readCollapeStateFromFields(state) {
  if (!state.fields) return; // for all repeating and group fields check for collapsed

  var fieldsIds = Object.keys(state.fields);
  fieldsIds.forEach(function (fieldId) {
    var field = state.fields[fieldId];
    if (!field || field.type !== 'repeating' && field.type !== 'datagroup') return;
    formHelper.setMetaProp(state, fieldId, 'collapsed', field.showCollapsed);
  });
};
/**
 * Calculate dependencies between fields
 * @param {import('./types').EcrionFormState} state
 */


var calculateFieldsDependencies = function calculateFieldsDependencies(state) {
  if (!state.fields) return; // for all the fields, calculate the visibility

  var fieldsIds = Object.keys(state.fields);
  fieldsIds.forEach(function (fieldId) {
    var field = state.fields[fieldId];
    if (!field) return;
    /** @type {Array<import('../formulas/types').FormulaToken>} */

    var dependencies = []; // if you know that more properties will depends on other fields, add here

    dependencies.push.apply(dependencies, _toConsumableArray(formulas.parseDependencies(field['maxItems'], state)));
    dependencies.push.apply(dependencies, _toConsumableArray(formulas.parseDependencies(field['minItems'], state)));
    dependencies.push.apply(dependencies, _toConsumableArray(formulas.parseDependencies(field['min'], state)));
    dependencies.push.apply(dependencies, _toConsumableArray(formulas.parseDependencies(field['max'], state)));
    dependencies.push.apply(dependencies, _toConsumableArray(formulas.parseDependencies(field['submitTmpl'], state)));
    dependencies.push.apply(dependencies, _toConsumableArray(formulas.parseDependencies(field['defaultValue'], state)));
    dependencies.forEach(function (d) {
      if (d.type !== 'field' || !d.id) return;
      state.dependencies[d.id] = state.dependencies[d.id] || [];
      if (!state.dependencies[d.id].includes(fieldId)) state.dependencies[d.id].push(fieldId);
    });
  });
};
/**
 *
 * @param {Document} form
 * @return {import('./types').EcrionFormState}
 */


var formLoader = function formLoader(form) {
  /**@type {import('./types').EcrionFormState} */
  var state = {
    stage: 'none'
  };
  if (!form) return state; // return DEFAULT_FORM_STATE;

  return createFormStateFromForm(form);
};

export default formLoader;